import { getOrCreateSyncClientId } from '$lib/db/sync';

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
};

export const subscribePush = async (apiBaseUrl: string, publicKey?: string) => {
  if (!('serviceWorker' in navigator)) return null;
  if (!publicKey) {
    console.warn('Missing VITE_PUSH_PUBLIC_KEY');
    return null;
  }

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  });

  await fetch(`${apiBaseUrl}/v1/notifications/subscribe`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ clientId: getOrCreateSyncClientId(), subscription })
  });

  return subscription;
};
